import React from "react";
import {
  FaPhoneAlt,
  FaFax,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowRight,
} from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact-container">
      {/* Chair, CIP Section */}
      <div className="contact-header">
        <h1>Chair, CIP</h1>
      </div>
      <div className="contact-content">
        <div className="contact-details">
          <h2>Dr. Harish N Dixit</h2>
          <p className="designation">
            Professor and Chairperson (CIP)
          </p>
          <p className="contact-line">
            <FaEnvelope className="icon" />
            <a href="mailto:chair@cip.iith.ac.in">chair@cip.iith.ac.in</a>
          </p>
                   <p className="contact-line">
            <FaPhoneAlt className="icon" />
            +91-40-23016901
          </p>
          <p className="contact-line">
            <FaFax className="icon" />
            +91-40-23016032
          </p>

          <p>Department of Mechanical & Aerospace Engineering</p>
          <p>IIT Hyderabad</p>
          <p>NH-65, Kandi</p>
          <p>Sangareddy, Telangana 502284</p>
        </div>
      </div>

      {/* Office, CIP Section */}
      <div className="contact-header">
        <h1>Office, CIP</h1>
      </div>
      <div className="contact-content">
        <div className="contact-details">
          <h2>Ms. Veena Bairy</h2>
          <p className="designation">Project Assistant (CIP)</p>
          <p className="contact-line">
            <FaEnvelope className="icon" />
            <a href="mailto:office@cip.iith.ac.in"> office@cip.iith.ac.in</a>
          </p>
          <p className="contact-line">
            <FaPhoneAlt className="icon" />
            +91 4023016901
          </p>
          <h3>Office of Centre for Interdisciplinary Programs (CIP) :</h3>
          <p>A-303, Academic A Block</p>
          <p>IIT Hyderabad</p>
          <p>NH-65, Kandi,</p>
          <p>Sangareddy, Telangana 502284</p>
        </div>

        {/* Location Section */}
        <div className="contact-location">
          <h3>
            <FaMapMarkerAlt className="icon" /> Location
          </h3>
          <p>
            The IITH campus is located near the National Highway 65 at Kandi,
            Sangareddy District, Telangana 502284.
          </p>
          <a
            className="direction-button"
            href="https://goo.gl/maps/LZChz1CeNGtKSZtz7"
            target="_blank"
            rel="noreferrer"
          >
            DIRECTIONS TO REACH IIT HYDERABAD <FaArrowRight className="arrow" />
          </a>
        </div>
      </div>

      {/* Embedded Google Map */}
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3803.1690037926073!2d78.1204651763522!3d17.594707796797213!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbefdc136bffbb%3A0x73414ff6594c9191!2sIndian%20Institute%20of%20Technology%2C%20Hyderabad!5e0!3m2!1sen!2sin!4v1741133736834!5m2!1sen!2sin"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="IIT Hyderabad Location"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
